import { Filters, PatientWorkQueueItem } from '../PatientWorkQueue.types';
import { FILTERS } from '../PatientWorkQueueTable.constants';
import { filterButtonsLogicMap } from './filterButtonsLogicMap';

export const applyFiltersToPatients = (
  patients: PatientWorkQueueItem[],
  filters: Filters[],
  userName: string
): PatientWorkQueueItem[] => {
  if (!filters.length) {
    return patients;
  }

  const scopedPatients = filters.includes(FILTERS.MY_ASSIGNMENTS)
    ? patients.filter((patient) => patient.assigned_username === userName)
    : patients;

  if (filters.length === 1 && filters.includes(FILTERS.MY_ASSIGNMENTS)) {
    return scopedPatients;
  }

  const combinedResults = filters
    .filter((filter) => filter !== FILTERS.MY_ASSIGNMENTS)
    .flatMap((filter) =>
      scopedPatients.filter((patient) =>
        filterButtonsLogicMap[filter]?.(patient)
      )
    );

  return Array.from(new Set(combinedResults));
};
